<div class="whitespace-nowrap">
  <span
    class="text-on-surface-subtle dark:text-on-surface-subtle-darkmode font-medium"
    [style.font-size]="fontSize()"
    [style.line-height]="'2.5rem'"
    [style.transition]="'font-size 150ms ease'"
  >
    {{ value() }}&nbsp;</span
  >
  <span #unitEl class="text-on-surface-variant dark:text-on-surface-variant-darkmode leading-6">
    <ng-content />
  </span>
</div>
